import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';
import lazyMessages from '../../i18n/lazy';
export var AccountMenuIntlProvider = function AccountMenuIntlProvider(_ref) {
  var children = _ref.children;
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  var messages = useMessages(locale);
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: messages
  }, children);
};
var useMessages = function useMessages(locale) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    messages = _useState2[0],
    setMessages = _useState2[1];
  useEffect(function () {
    if (/^en(-US)?$/i.exec(locale)) {
      // Use fallback messages, which are already US English
      setMessages(undefined);
    } else {
      var cancelled = false;
      loadMessages(locale).catch(function (_error) {
        return undefined;
      }) // TODO: Log error somehow (analytics?)
      .then(function (messages) {
        if (!cancelled) {
          setMessages(messages);
        }
      });
      return function () {
        cancelled = true;
      };
    }
  }, [locale, setMessages]);
  return messages;
};
var loadMessages = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    var _yield, _ref3;
    var _locale$split, _locale$split2, language, _locale$split2$, region;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _locale$split = locale.split('-', 2), _locale$split2 = _slicedToArray(_locale$split, 2), language = _locale$split2[0], _locale$split2$ = _locale$split2[1], region = _locale$split2$ === void 0 ? '' : _locale$split2$;
          language = language.toLowerCase();
          region = region.toUpperCase();
          _context.next = 5;
          return (_ref3 = lazyMessages["".concat(language, "_").concat(region)] || lazyMessages[language]) === null || _ref3 === void 0 ? void 0 : _ref3();
        case 5:
          _context.t1 = _yield = _context.sent;
          _context.t0 = _context.t1 === null;
          if (_context.t0) {
            _context.next = 9;
            break;
          }
          _context.t0 = _yield === void 0;
        case 9:
          if (!_context.t0) {
            _context.next = 13;
            break;
          }
          _context.t2 = void 0;
          _context.next = 14;
          break;
        case 13:
          _context.t2 = _yield.default;
        case 14:
          return _context.abrupt("return", _context.t2);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadMessages(_x) {
    return _ref2.apply(this, arguments);
  };
}();